import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useOrganization } from '../../hooks/useOrganization';
import { orgHomePath } from '../../lib/featureFlags';

/**
 * RootRedirect - Handle initial routing based on user's organization state
 *
 * States:
 * - No organizations: Show waiting state
 * - Single organization: Redirect to that org's dashboard
 * - Multiple organizations: Show org picker
 */
const RootRedirect = () => {
  const { loading: authLoading, hasOrganizations, isSingleOrg, organizations, hasNoOrg } = useAuth();
  const { isLoading: orgLoading, currentOrg } = useOrganization();

  // Show nothing while loading
  if (authLoading || orgLoading) {
    return null;
  }

  // User has no organizations - show waiting state
  if (hasNoOrg) {
    return <Navigate to="/waiting" replace />;
  }

  // User has a current org selected (from localStorage or single org)
  if (currentOrg) {
    return <Navigate to={orgHomePath(currentOrg.slug)} replace />;
  }

  // Single org user without current org set - redirect to that org
  if (isSingleOrg && organizations.length > 0) {
    return <Navigate to={orgHomePath(organizations[0].slug)} replace />;
  }

  // Multi-org user without selection - show org picker
  if (hasOrganizations) {
    return <Navigate to="/organizations" replace />;
  }

  // Fallback - shouldn't reach here
  return <Navigate to="/waiting" replace />;
};

export default RootRedirect;
